












import { Component, Vue, Prop } from 'vue-property-decorator'
import { sleep } from '@ivy/fts/utils'

@Component
export default class BulletinBoard extends Vue {
  @Prop() noticeList: any[]
  number: number = 0

  mounted() {
    this.startMove()
  }

  get textContent() {
    return {
      key: this.number,
      val: this.noticeList[this.number].name,
    }
  }

  async startMove() {
    await sleep(3000)
    if (this.number === this.noticeList.length - 1) {
      this.number = 0
    } else {
      this.number += 1
    }
    this.startMove()
  }
}
